import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withMountListener } from '@beef/react';
import { getTargetTariffType } from "./OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { FTTBOrderTariffInlineFormPopup } from "./OrderTariffFormInlinePopup";
import { selectCheckAddressOneFieldPopupEnabled } from "./OrderTariffFormOldPopup/store/selectors/modal";
import { OrderTariffThreeFieldsPopup } from "./OrderTariffFormOldPopup";
import { ymOrderTariffIsOpen } from "./OrderTariffFormOldPopup/analytics";
import { initDataAndApiTexts } from "./OrderTariffFormOldPopup/store/actions/initDataAndApiTexts";
var OrderTariffFormPopup = function OrderTariffFormPopup(_ref) {
  var tariffData = _ref.tariffData,
    isCheckAddressOneFieldPopupEnabled = _ref.isCheckAddressOneFieldPopupEnabled;
  useEffect(function () {
    if (tariffData.tariffType) ymOrderTariffIsOpen(tariffData);
  }, [tariffData]);
  return isCheckAddressOneFieldPopupEnabled ? /*#__PURE__*/React.createElement(FTTBOrderTariffInlineFormPopup, {
    "data-t-id": "components-OrderTariffFormPopup"
  }) : /*#__PURE__*/React.createElement(OrderTariffThreeFieldsPopup, null);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    tariffData: getTargetTariffType(state),
    isCheckAddressOneFieldPopupEnabled: selectCheckAddressOneFieldPopupEnabled(state)
  };
};
var mapDispatchToProps = {
  onMount: initDataAndApiTexts
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var OrderTariffFormPopupWithStore = compose(connector, withMountListener)(OrderTariffFormPopup);
export { OrderTariffFormPopupWithStore as FTTBOrderTariffFormPopup };